export var machineErrorState = {
  type: 'final'
};